import React from 'react'
import classNames from 'classnames'
import { NextPage } from 'next'
import { HeadingLG, ParagraphLG } from '@/atoms/Text'
import { fetchNowStreamingProjects } from '@/services/GuildSignupPageService'
import { NowStreamingContent } from '@/services/NowStreamingService'
import { useUserRegion } from '@/services/UserRegionService'
import { getServerSidePropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { GuildNowStreamingRail } from '@/views/GuildSignupView/GuildBodySection/GuildNowStreamingRail'
import { AppPromoSection } from '@/views/LandingView/AppPromoSection'

interface WhatsInMyRegionPageProps {
  region: string | null
  nowStreamingProjects: NowStreamingContent[]
}

export const WhatsInMyRegionPage: NextPage<WhatsInMyRegionPageProps> = ({
  region: serverRegion,
  nowStreamingProjects,
}) => {
  const { t } = useTranslate('guild')
  const { region: clientRegion, loading } = useUserRegion()
  const region = serverRegion ?? clientRegion

  return (
    <div>
      <section className="px-4 pt-[104px] md:px-8">
        <HeadingLG weight="bold" color="white">
          <Translate t={t} i18nKey="checkOutWhatsStreaming">
            Check Out What&apos;s Streaming on Angel
          </Translate>
        </HeadingLG>
        <div className={classNames({ 'opacity-0': !serverRegion && loading })}>
          <ParagraphLG weight="normal" color="core-gray-300" className="py-8">
            <Translate t={t} i18nKey="weStriveToMakeShowsAvaialble" values={{ region }}>
              We strive to make our shows as widely available as possible but some titles may not be available
              everywhere. Below you can see everything available for streaming to Guild members in your region, which
              appears to be <span className="font-bold text-white">{{ region }}</span>.
            </Translate>
          </ParagraphLG>
          <GuildNowStreamingRail
            title={t('nowStreamingInRegion', 'Now Streaming in {{region}}', { region })}
            initialProjects={nowStreamingProjects}
          />
        </div>
      </section>
      <AppPromoSection containerClassName="h-full pt-10 !pb-0" simplified />
    </div>
  )
}

export const getServerSideProps = getServerSidePropsErrorHandler<WhatsInMyRegionPageProps>(
  async ({ federationClient, locale, region }) => {
    const nowStreamingProjects = await fetchNowStreamingProjects(federationClient, [])

    return {
      props: {
        ...(await loadTranslations(locale, ['common', 'app-promo', 'account', 'guild'])),
        region,
        nowStreamingProjects,
      },
    }
  },
)

export default WhatsInMyRegionPage
